import FJAppLeft from '../../../FJMainPreview/FJAppLeft/FJAppLeft';
import FJImageExtenderImageUploadContainer from '../container/FJImageExtenderImageUploadContainer';
import FJImageExtenderRatioContainer from '../container/FJImageExtenderRatioContainer';
import FJGenerateButton from '../../../../common/components/FJGenerateButton/FJGenerateButton';
import styles from './FJImageExtenderLeft.module.less';
import PropTypes from 'prop-types';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller';
import FJImageExtenderGenerateNumberContainer from '../container/FJImageExtenderGenerateNumberContainer';

const FJImageExtenderLeft = ({ generate, taskStatus, freeNumCreation, useCredit, creditNumber, isProjectLoading }) => {
    return (
        <FJAppLeft>
            <FJVerticalScroller className={styles.scroller}>
                <div className={styles.content}>
                    <FJImageExtenderImageUploadContainer />

                    <FJImageExtenderRatioContainer />

                    <FJImageExtenderGenerateNumberContainer />
                </div>
            </FJVerticalScroller>

            <FJGenerateButton
                className={styles.generate_btn}
                onClick={generate}
                taskStatus={taskStatus}
                isFree={freeNumCreation > 0 && useCredit > creditNumber}
                freeNumCreation={freeNumCreation}
                useCredit={useCredit}
                isProjectLoading={isProjectLoading}
                isShowUsageDetail={true}
            />
        </FJAppLeft>
    );
};

FJImageExtenderLeft.propTypes = {
    generate: PropTypes.func,
    taskStatus: PropTypes.string,
    freeNumCreation: PropTypes.number,
    useCredit: PropTypes.number,
    creditNumber: PropTypes.number,
    isProjectLoading: PropTypes.bool,
};

export default FJImageExtenderLeft;
